import React, {useEffect, useState} from "react";
import {useSubheader} from "../../../_metronic/layout";
import {
	Checkbox,
	Paper,
	Table,
	TableBody,
	TableCell,
	TablePagination,
	TableRow,
	IconButton,
	Popover,
	Typography
} from "@material-ui/core";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import makeRequest from "../../api/makeRequest";
import moment from "moment-jalaali";
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import apiConfig from "../../config/apiConfig";
import {Share as ShareIcon, VpnKey as KeyIcon} from "@material-ui/icons";
import OfferBar from "../../components/OfferBar";

export const ServicesPage = () => {
	const { t } = useTranslation('common');
	const headRows = [
		{id: "id", disablePadding: true, label: t('Id')},
		{id: "display_image", disablePadding: false, label: t('DisplayImage')},
		{id: "name", disablePadding: false, label: t('Name')},
		{id: "display_name", disablePadding: false, label: t('DisplayName')},
		{id: "display_login_name", disablePadding: false, label: t('DisplayLoginName')},
		{id: "max_user", disablePadding: false, label: t('UserCapacity')},
		// {id: "max_time", disablePadding: false, label: "ظرفیت نفر/دقیقه"},
		{id: "video_limit", disablePadding: false, label: t('VideoLimitations')},
		// {id: "time_usage", disablePadding: false, label: "نفر/دقیقه مصرف شده"},
		{id: "expire_date", disablePadding: false, label: t('ExpirationDate')},
		{id: "api_key", disablePadding: false, label: 'API'},
		{id: "active", disablePadding: false, label: t('ActiveInactive')}
	];
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('Services'));

	const [Services, setServices] = useState([])

	const [anchorEl, setAnchorEl] = useState(null);
	const [openAPI,setOpenAPI] = useState(0)
	const [apiKey, setApiKey] = useState('');

	useEffect(() => {
		moment.loadPersian();

		const getServices = async () => {
			try {
				const {data} = await makeRequest('getService', {})
				const service = data.service
				setServices([service])
				setApiKey(service.api_token)
			} catch (e) {
				console.log(e)
			}
		}

		getServices()
	}, [])

	const [selected, setSelected] = React.useState([]);
	const [orderBy, setOrderBy] = React.useState("public_id");
	const [order, setOrder] = React.useState("asc");
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	function handleSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = Services.map(n => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	}

	function createData(obj) {
		const {
			public_id,
			name,
			max_user,
			max_time,
			video_limit,
			time_usage,
			expire_date,
			active
		} = obj
		return {
			public_id,
			name,
			max_user,
			max_time,
			video_limit,
			time_usage,
			expire_date,
			active
		};
	}

	function stableSort(array, cmp) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = cmp(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map(el => el[0]);
	}

	function desc(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getSorting(order, orderBy) {
		return order === "desc"
			? (a, b) => desc(a, b, orderBy)
			: (a, b) => -desc(a, b, orderBy);
	}

	const isSelected = name => selected.indexOf(name) !== -1;

	function handleClick(event, name) {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	}

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, Services.length - page * rowsPerPage);

	function handleChangePage(event, newPage) {
		setPage(newPage);
	}

	function handleChangeRowsPerPage(event) {
		setRowsPerPage(parseInt(event.target.value, 10));
	}

	return (
		<>
			<OfferBar/>
			<div className="new-service">
				<Link to={'/plan'}><Button variant="primary mb-5 mx-5">{t('NEW.SERVICE')}</Button></Link>
				{Services && Services[0] && <Link to={`/plan?plan_id=${Services[0].plan ? Services[0].plan.public_id : 0}`}><Button variant="outline-primary mb-5">{t('UPDATE.SERVICE')}</Button></Link>}
				<Link to={'/service/modify'}><Button variant="secondary mb-5 mx-5">{t('ServiceInformation')}</Button></Link>
			</div>
			<Paper className={"classes.paper"}>
				<div className={"tableWrapper"}>
					<Table
						className={"classes.table"}
						aria-labelledby="tableTitle"
						size={"medium"}
					>
						<EnhancedTableHead
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={Services.length}
							headRows={headRows}
						/>
						<TableBody>
							{stableSort(Services, getSorting(order, orderBy))
								.map((row, index) => {
									const isItemSelected = isSelected(row.name);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										<TableRow
											hover
											onClick={event => handleClick(event, row.id)}
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<TableCell padding="checkbox">
												<Checkbox
													checked={isItemSelected}
													inputProps={{
														"aria-labelledby": labelId
													}}
												/>
											</TableCell>
											<TableCell
												component="th"
												id={labelId}
												align="right"
											>
												{row.id}
											</TableCell>
											<TableCell align="right">{row.display_image ? <img style={{
												width: "50px",
												height: "50px",
												borderRadius: "50%",
												display: "block",
												margin: "0 auto"
											}
											} src={`${apiConfig.BASE_URL}${row.display_image}`} alt={'service image'}/> : 'Default'}</TableCell>
											<TableCell align="right">{row.name}</TableCell>
											<TableCell align="right">{row.display_name ? row.display_name : 'My Service'}</TableCell>
											<TableCell align="right">{row.display_login_name ? row.display_login_name : 'Login'}</TableCell>
											<TableCell align="right">{row.max_user}</TableCell>
											{/*<TableCell align="right">{row.max_time}</TableCell>*/}
											<TableCell align="right">{row.video_limit}</TableCell>
											{/*<TableCell align="right">{row.time_usage}</TableCell>*/}
											<TableCell align="right">{moment.unix(row.expire_date).format("HH:mm jYYYY/jMM/jDD")}</TableCell>
											<TableCell align="right">
												<IconButton onClick={(e)=>{
													setAnchorEl(e.currentTarget);
													setOpenAPI(row.id)
												}} color="primary" component="span" style={{
													width: '40px !important'
												}}>
													<KeyIcon/>
												</IconButton>
												<Popover
													anchorEl={anchorEl}
													id={`${row.id}-share-pop`}
													open={openAPI === row.id && Boolean(anchorEl)}
													onClose={()=>setAnchorEl(null)}
													transformOrigin={{
														vertical: 'bottom',
														horizontal: 'left',
													}}
												>
													<Typography style={{ padding: "1em", color: "#5f5f5f" }}>https://online.bellmeet.com/api/{apiKey}</Typography>
												</Popover>
											</TableCell>
											<TableCell align="right">{row.active ? t('Yes') : t('No')}</TableCell>
										</TableRow>
									);
								})}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50, 100]}
					component="div"
					labelRowsPerPage={t('NumberPerPage')}
					count={Services.length}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						"aria-label": "Previous Page"
					}}
					nextIconButtonProps={{
						"aria-label": "Next Page"
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
		</>
	);
};
